export const WHATSAPP_NUMBER = "5593991165579";
export const WHATSAPP_ECOLOJA = "5593991177997"; // Eco Loja Tapajós & Movelaria Anambé
export const INSTAGRAM = "coomflona.oficial";
export const INSTAGRAM_URL = "https://instagram.com/coomflona.oficial";
export const COOMFLONA_LOGO = "https://customer-assets.emergentagent.com/job_cooperative-web-1/artifacts/ftu7izsv_LOGO%20COOMFLONA%20BRANCO.png";
export const ECO_LOJA_LOGO = "https://customer-assets.emergentagent.com/job_cooperative-web-1/artifacts/fuy46lvq_eco0101.png";

export const HERO_AMAZON = "https://images.pexels.com/photos/7867865/pexels-photo-7867865.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600";
export const RIVER_SUNSET = "https://images.pexels.com/photos/28587113/pexels-photo-28587113.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600";
export const INDIGENOUS_CRAFTS = "https://images.unsplash.com/photo-1574340328953-5f8e6ab676e7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxpbmRpZ2Vub3VzJTIwYmFza2V0cnklMjBjcmFmdHxlbnwwfHx8fDE3NzY3MjkzNDh8MA&ixlib=rb-4.1.0&q=85";
export const WOOD_FURNITURE = "https://images.pexels.com/photos/19339614/pexels-photo-19339614.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600";
export const COPAIBA_OIL = "https://images.unsplash.com/photo-1671492245104-bc7bb48ee567?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxlc3NlbnRpYWwlMjBvaWwlMjBhbWJlciUyMGdsYXNzJTIwYm90dGxlfGVufDB8fHx8MTc3NjcyOTMzMnww&ixlib=rb-4.1.0&q=85";

// Fotos oficiais COOMFLONA
export const COOMFLONA_TEAM = "https://customer-assets.emergentagent.com/job_cooperative-web-1/artifacts/jxm78qgy_coomflona%200101.png";
export const COOMFLONA_MISSION_CARD = "https://customer-assets.emergentagent.com/job_cooperative-web-1/artifacts/2gh23xyz_Apresenta%C3%A7%C3%A3o%20coop-COOMFLONA%2001.png";
export const COOMFLONA_MANEJO = "https://customer-assets.emergentagent.com/job_cooperative-web-1/artifacts/0ipiimtz_Apresenta%C3%A7%C3%A3o%20coop-COOMFLONA.png";

// Fotos reais de campo — COOMFLONA
export const PHOTO_MOVELARIA = "https://customer-assets.emergentagent.com/job_cooperative-web-1/artifacts/as6ns1nv_IMG_3087.jpg";
export const PHOTO_INVENTORY = "https://customer-assets.emergentagent.com/job_cooperative-web-1/artifacts/b2sd8lh3_IMG_3738.jpg";
export const PHOTO_BASE_KM117 = "https://customer-assets.emergentagent.com/job_cooperative-web-1/artifacts/z7qu3tka_base%20km%20117.jpg";

export const whatsappLink = (message = "") => {
  const msg = encodeURIComponent(message || "Olá! Gostaria de mais informações sobre a COOMFLONA.");
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${msg}`;
};

// WhatsApp exclusivo da Eco Loja Tapajós e Movelaria Anambé (produtos)
export const whatsappEcoLojaLink = (message = "") => {
  const msg = encodeURIComponent(message || "Olá! Gostaria de mais informações sobre os produtos da Eco Loja Tapajós.");
  return `https://wa.me/${WHATSAPP_ECOLOJA}?text=${msg}`;
};

export const CATEGORIES = [
  { key: "todos", label: "Todos" },
  { key: "oleos", label: "Óleos Vegetais & Mel" },
  { key: "artesanato", label: "Artesanato" },
  { key: "movelaria", label: "Movelaria Anambé" },
];

export const formatBRL = (value) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value || 0);

export const priceLabel = (value) =>
  !value || Number(value) === 0 ? "Sob consulta" : formatBRL(value);

export const formatDate = (iso) => {
  try {
    return new Intl.DateTimeFormat("pt-BR", { day: "2-digit", month: "long", year: "numeric" }).format(new Date(iso));
  } catch {
    return "";
  }
};
